module.exports = __webpack_public_path__ + "img/payme_btn.9d19997c.svg";